import React from 'react';
import dayjs from "dayjs";

import Typography from "@mui/joy/Typography";
import Chip from "@mui/joy/Chip";
import {Stack} from "@mui/joy";
import Divider from "@mui/joy/Divider";

// context
import UserSubscriberContext from "../../context/UserSubscriberContext";

// components
import withNavigate from "../../utils/withNavigate";
import ProfileHorizontalByProps from "../Profile/ProfileHorizontalByProps";
import AccountCard from "../Cards/AccountCard";
import OpportunityCard from "../Cards/OpportunityCard";
import TaskEditPhaseModal from "./TaskEditPhaseModal";

// icons
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import WarningIcon from "@mui/icons-material/Warning";


class TaskCardInner extends React.Component{
    static contextType = UserSubscriberContext;

    render(){
        return(
            <Stack
                spacing={1}
            >
                <Stack
                    direction={'row'}
                    spacing={1}
                    useFlexGap
                    sx={{
                        flexWrap: 'wrap',
                        alignItems: 'center'
                    }}
                >
                    <Chip
                        sx={{
                            mr: 1
                        }}
                    >
                        # {this.props.task.id}
                    </Chip>
                    <Typography
                        level={'title-md'}
                    >
                        {this.props.task.title}
                    </Typography>
                    {
                        this.props.task.work_status === 'COM' && (!this.props.task.result || this.props.task.result === '')?
                            <Chip
                                color={'warning'}
                                startDecorator={<WarningIcon />}
                            >
                                НЕТ РЕЗУЛЬТАТОВ
                            </Chip>:
                            null
                    }
                </Stack>
                <Divider />
                <Stack
                    direction={'row'}
                    spacing={1}
                    useFlexGap
                    sx={{
                        flexWrap: 'wrap',
                        alignItems: 'center'
                    }}
                >
                    {
                        this.context.subscriberObject.external?
                            this.props.task.account.nameshort:
                            <AccountCard
                                account={this.props.task.account}
                                mini={true}
                            />
                    }
                    {
                        this.props.task.opportunity && !this.props.hideOpportunity?
                            <OpportunityCard
                                opportunity={this.props.task.opportunity}
                                nano={true}
                            />
                        :
                        null
                    }
                </Stack>
                {
                    !this.props.hidePhase && this.props.task.opportunity ?
                        this.props.task.phase?
                            <Stack
                                direction={'row'}
                                spacing={1}
                                useFlexGap
                                sx={{
                                    flexWrap: 'wrap',
                                    alignItems: 'center'
                                }}
                            >
                                <Chip
                                    color={"warning"}
                                >
                                    к этапу&nbsp;#{this.props.task.phase.revision_fk.id}:{this.props.task.phase.id} {this.props.task.phase.title.slice(0,30)}{this.props.task.phase.title.length > 30?'...':''}
                                </Chip>
                                {
                                    this.props.task.executor.id === this.context.userObject.id?
                                        <TaskEditPhaseModal
                                            task={this.props.task}
                                            callBack={this.props.callBack}
                                        />:
                                        null
                                }
                            </Stack>:
                            <Stack
                                direction={'row'}
                                spacing={1}
                                useFlexGap
                                sx={{
                                    flexWrap: 'wrap',
                                    alignItems: 'center',
                                }}
                            >
                                <Chip
                                    color={"neutral"}
                                >
                                    Этап трудоемкости не указан
                                </Chip>
                                {
                                    this.props.task.executor.id === this.context.userObject.id?
                                        <TaskEditPhaseModal
                                            task={this.props.task}
                                            callBack={this.props.callBack}
                                        />:
                                        null
                                }
                            </Stack>
                            :
                        null
                }
                <Stack
                    direction={'row'}
                    spacing={1}
                    useFlexGap
                    sx={{
                        flexWrap: 'wrap',
                        alignItems: 'center'
                    }}
                >
                    <ProfileHorizontalByProps
                        user={this.props.task.owner}
                    />
                    <ArrowRightAltIcon/>
                    <ProfileHorizontalByProps
                        user={this.props.task.executor}
                    />
                    <Chip
                        color={this.props.task.work_status === 'COM'?'success':dayjs(this.props.task.end_dt)>dayjs()?'success':'danger'}
                    >
                         с {dayjs(this.props.task.start_dt).format('DD.MM.YYYY')} по {dayjs(this.props.task.end_dt).format('DD.MM.YYYY')}
                    </Chip>
                    {
                        !this.props.hideEstimation?
                            <>
                                <Chip>
                                    {this.props.task.duration_fact} из {this.props.task.duration_plan}
                                </Chip>
                                <Chip>
                                    {this.props.task.complete} %
                                </Chip>
                            </>:
                            null
                    }
                </Stack>
            </Stack>
        )
    }
}

export default withNavigate(TaskCardInner)
